var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateOrgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 44,
    viewBox: "0 0 51 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40039 31.8V3.8C9.40039 2.2536 10.654 1 12.2004 1H47.2004C48.7468 1 50.0004 2.2536 50.0004 3.8V31.8C50.0004 33.3464 48.7468 34.6 47.2004 34.6H12.2004C10.654 34.6 9.40039 33.3464 9.40039 31.8Z",
    fill: "#E3F2FD",
    stroke: "#2962FF",
    strokeWidth: 1.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 40.1999V12.1999C1 10.6535 2.2536 9.3999 3.8 9.3999H38.8C40.3464 9.3999 41.6 10.6535 41.6 12.1999V40.1999C41.6 41.7463 40.3464 42.9999 38.8 42.9999H3.8C2.2536 42.9999 1 41.7463 1 40.1999Z",
    fill: "white",
    stroke: "#2962FF",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 40.2V11.8C1 10.2536 2.2536 9 3.8 9H8.2C9.7464 9 11 10.2536 11 11.8V40.2C11 41.7464 9.7464 43 8.2 43H3.8C2.2536 43 1 41.7464 1 40.2Z",
    stroke: "#2962FF",
    strokeWidth: 1.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20.6001V16.4001C15 14.8537 16.2536 13.6001 17.8 13.6001H34.6C36.1464 13.6001 37.4 14.8537 37.4 16.4001V20.6001C37.4 22.1465 36.1464 23.4001 34.6 23.4001H17.8C16.2536 23.4001 15 22.1465 15 20.6001Z",
    stroke: "#2962FF",
    strokeWidth: 1.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 36V31.8C15 30.2536 16.2536 29 17.8 29H34.6C36.1464 29 37.4 30.2536 37.4 31.8V36C37.4 37.5464 36.1464 38.8 34.6 38.8H17.8C16.2536 38.8 15 37.5464 15 36Z",
    stroke: "#2962FF",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateOrgIcon);
export default __webpack_public_path__ + "static/media/createOrgIcon.adc699e78ef548055befde3a28c764b0.svg";
export { ForwardRef as ReactComponent };